<template>
  <v-container class="pa-1">
    <!-- <v-layout justify-space-around row>
      <v-flex>
        <v-card class="dashBlock">
          <v-layout justify-space-between row>
            <v-flex>
              <p>Amount Riders</p>
              <p class="numTitle">--</p>
            </v-flex>

            <v-flex>
              <p>Active</p>
              <p style="color:green;">-</p>
              <p>Inactive</p>
              <p style="color:red;">-</p>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="dashBlock">
          <p>Rider revenue</p>
          <p class="numTitle">--</p>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="dashBlock">
          <p>Total Transfer</p>
          <p class="numTitle">--</p>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="dashBlock">
          <p>Total Revenue</p>
          <p class="numTitle">--</p>
        </v-card>
      </v-flex>
    </v-layout> -->

    <v-layout row>
      <v-flex>
        <v-btn
          color="#FFD600"
          class="btnReport ml-2"
          :to="
            '/weserve_admin_login/control/' +
            $store.state.backOffice.province +
            '/report/rider_report'
          "
          v-if="permission.report.rider.rider_user_report"
        >
          <v-icon>insert_drive_file</v-icon>
          <span class>Rider report</span>
        </v-btn>
        <v-btn
          color="#FFD600"
          class="btnReport ml-2"
          v-if="permission.report.rider.extra_credit_report"
          :to="
            '/weserve_admin_login/control/' +
            $store.state.backOffice.province +
            '/report/extra_credit_zone_report'
          "
        >
          <v-icon>insert_drive_file</v-icon>
          <span class>Extra credit zone report</span>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
</style>

<script>
import { mapState } from "vuex";
export default {
  computed: {},
  computed: {
    ...mapState({
      permission: (state) => state.permission,
    }),
  },
};
</script>
